var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack380({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,.87A4.79,4.79,0,0,1,10.37,6.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,1.77A3.88,3.88,0,0,1,9.47,6.26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.37,6.2A4.79,4.79,0,0,0,5,.87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.47,6.26A3.88,3.88,0,0,0,5,1.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.93,2.66A3,3,0,0,1,8.58,6.31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.58,6.31A3,3,0,0,0,4.93,2.66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.69,
    y: 9.44,
    width: 14.63,
    height: 5.72
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.13,13.13,2.7,13a1.09,1.09,0,0,0,.28.66.84.84,0,0,0,.6.21.86.86,0,0,0,.58-.18.64.64,0,0,0,.2-.48.47.47,0,0,0-.17-.38,2.42,2.42,0,0,0-.59-.23,4.75,4.75,0,0,1-.9-.35,1,1,0,0,1-.35-.39,1.23,1.23,0,0,1-.12-.55,1.15,1.15,0,0,1,.33-.86,1.27,1.27,0,0,1,.95-.34,1.53,1.53,0,0,1,.66.14,1,1,0,0,1,.44.37,1.6,1.6,0,0,1,.21.66l-.56.09a.68.68,0,0,0-.74-.68.89.89,0,0,0-.56.15.48.48,0,0,0-.18.38.43.43,0,0,0,.18.37,2.94,2.94,0,0,0,.62.24,5.16,5.16,0,0,1,.93.37.83.83,0,0,1,.32.37,1.18,1.18,0,0,1,.12.55,1.24,1.24,0,0,1-.38,1,1.38,1.38,0,0,1-1,.37A1.34,1.34,0,0,1,2.13,13.13Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.54,
    y1: 4.29,
    x2: 3.54,
    y2: 9.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack380);
export default __webpack_public_path__ + "static/media/Symbol_pack_380.036c12d35e3459002d21d799004f065d.svg";
export { ForwardRef as ReactComponent };